export var TableAutoHeightType;
(function (TableAutoHeightType) {
    TableAutoHeightType["maxHeight"] = "maxHeight";
    TableAutoHeightType["minHeight"] = "minHeight";
})(TableAutoHeightType || (TableAutoHeightType = {}));
